import { Injectable } from '@angular/core';
import { UserManager, UserManagerSettings } from 'oidc-client';
import { Router } from '@angular/router';
import { Subject, Observable } from "rxjs";
import { ConfigurationService } from './configuration.service';
import { ClientAuth } from './../models/configuration';
import { HttpHeaders } from '@angular/common/http';

export function getClientSettings(authSettings: ClientAuth): UserManagerSettings {
  return {
    authority: authSettings.authority,
    client_id: authSettings.clientId,
    redirect_uri: authSettings.redirectUri,
    post_logout_redirect_uri: authSettings.postLogoutRedirectUri,
    response_type: "id_token token",
    scope: "openid profile CatalystPortal DatafinchBilling",
    filterProtocolClaims: true,
    loadUserInfo: true
  };
}

@Injectable()
export class AuthenticationService {

  private manager: UserManager;
  private access_token: string | null;
  private token_type: string | null;
  private identity_token: string | null;
  private clientAuth: ClientAuth;
  private authHttpOptions: any;

  constructor(private router: Router, private configService: ConfigurationService) {

    let config = configService.config.clientAuth;
    this.clientAuth = config;
    this.manager = new UserManager(getClientSettings(config));
  }


  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect({ data: this.clientAuth.redirectUri });
  }

  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      this.access_token = user.access_token;
      this.token_type = user.token_type;
      this.identity_token = user.id_token;
      localStorage.setItem("userId", user.profile.sub);
      localStorage.setItem("orgPrefix", user.profile.organization);

      this.authHttpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `${this.token_type} ${this.access_token}`
        }),
        withCredentials: true
      };
    });
  }

  getAuthHttpOptions(): object {
    return this.authHttpOptions;
  }

  startLogOut(): Promise<void> {
    // Forces signout to always use an id token hint so the user is never prompted
    return this.manager.signoutRedirect({ id_token_hint: this.identity_token }).then(x => {
    });
  }
}
